import { Avatar, Tooltip } from '@mui/material'
import { ReactNode } from 'react'

type Props = {
  children: ReactNode
  src?: string
  title: string | JSX.Element
}
const CustomAvatar = ({ children, src, title }: Props) => {
  return (
    <Tooltip arrow placement="top" title={title}>
      <Avatar style={{ width: '1.875rem', height: '1.875rem' }} src={src}>
        {children}
      </Avatar>
    </Tooltip>
  )
}

export { CustomAvatar }
